<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
    extends: baseEdit,
    components: {},
    data() {
        return {
            mname: "deciceType",
            key: 'id',
            url: {
                get: '/admin/system/modelLibrary',
                add: '/admin/system/modelLibrary',
                edit: '/admin/system/modelLibrary',
            },
            items: [
                { label: "基本信息", desc: "表单的基本信息", type: "header" },
                {
                    label: "型号名称",
                    name: "modelName",
                    value: "",
                    type: "input",
                    width: '400px',
                    rules: [{ required: true, trigger: "blur" }],
                },
                {
                    label: "资产类型",
                    name: "facilityTypeId",
                    value: "",
                    type: "select",
                    width: "400px",
                    dropList: [],
                    rules: [
                        {
                            required: true,
                            message: "资产类型不能为空",
                            trigger: "blur",
                            type: "number",
                        },
                    ],
                },
                {
                    label: "品牌名称",
                    name: "brandName",
                    value: "",
                    type: "input",
                    width: '400px',
                },
            ],
            forms: {},
        };
    },
    created() {
        this.loadFacilityData()
    },
    methods: {
        async loadFacilityData() {
            let q = {};
            let res = await $utils.api.load(`/admin/system/facilityType/list`, q);
            if (res && res.rows) {
                let ll = res.rows;
                let dropList = [];
                for (let index = 0; index < ll.length; index++) {
                    const element = ll[index];
                    let xx = {};
                    xx.value = element.id;
                    xx.name = element.facilityName;
                    dropList.push(xx);
                }
                for (let index = 0; index < this.items.length; index++) {
                    const element = this.items[index];
                    if (element && element.name == "facilityTypeId") {
                        this.items[index]["dropList"] = dropList;
                    }
                }
            }
        },
    },
};
</script>
